// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/cvfr-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/cvfr-procedures/cvfr-ifr-weather-response.js';
import g1 from '../lessons/air-law/cvfr-procedures/cvfr-procedures.js';

mount([g0, g1]);
